import _ from 'lodash';

import React, { Fragment } from 'react';
import EditProfile from './edit-profile';
import CardModal from './card-modal';
import ManageSubscriptions from './manage-subscriptions';
import {toast} from 'react-toastify';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import queryString from 'query-string';
import { Route, NavLink, useHistory, useLocation } from 'react-router-dom';


const AccountMenu = ({member, notifyUpdate, errorUpdate}) => {
    const history = useHistory();
    return (
        <Fragment>
            <div className="row expanded" style={{width: '99.1vw', padding:'2vw'}}>
                <div className="large-6">
                    <div style={{minHeight: '45vh'}}>
                        <EditProfile notify={() => {notifyUpdate()}} errorToast={errorUpdate} member={member}/>
                    </div>
                    <div className="margin-top-3">
                        <CardModal notify={() => {notifyUpdate(history)}}/>
                    </div>
                </div>
                
                <div className="large-6">
                <div style={{minHeight: '45vh'}}>
                        <ManageSubscriptions cancelled={false} member={member}/>
                    </div>
                    <div className="margin-top-3">
                        <ManageSubscriptions cancelled={true} member={member}/>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

const notifyUpdate = (history) => {
    toast.success("Changes saved.", {
        position: "top-right",
        autoClose: 1200,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0,
        progress: undefined,
        onClose: () => { 
            const { search } = history.location;
            const values = queryString.parse(search);
            if(!_.isEmpty(values)) {
                if(Object.keys(values)[0].includes('redirectTo')) {
                    // console.log(values.redirectTo);
                    
                    history.push(`/artist/${values[Object.keys(values)[0]]}/tracks`)
                    location.reload(); 
                }
            }
            else {
                location.reload(); 
            }
        }

    });

}
const errorUpdate = () => {
    toast.error("An error occurred while saving changes.", {
        position: "top-right",
        autoClose: 1200,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0,
        progress: undefined,
    });

}

function ManageAccount (props) {
    return (
        <AccountMenu member={props.member} notifyUpdate={notifyUpdate} errorUpdate={errorUpdate}/>
    )

   
}

export default ManageAccount;